module.exports = __webpack_public_path__ + "static/media/g_icon.cae7beb4.png";